module.exports = __webpack_public_path__ + "static/media/TA272_2.429e4490.png";